import * as api from '../lib/api';
import {types, flow} from 'mobx-state-tree';

const User = types
  .model('User', {
    email: types.string,
    role: types.string,
    address: types.string,
    balance: 0
  })
  .views((self) => ({
    get balanceFormatted() {
      return (self.balance / 100).toFixed(2);
    }
  }))
  .actions((self) => {
    const updateBalance = flow(function* () {
      try {
        const {balance} = yield api.fetchBalance();
        self.balance = balance;
      } catch (error) {
        console.error(error);
      }
    });
    return {updateBalance};
  });

export default User;
